import { styled } from '@mui/material/styles'

import { MOBILE_BREAKPOINT } from './styled'

const mobileOnly = `@media (max-width: ${MOBILE_BREAKPOINT}px)`

export const TOP_BAR_HEIGHT = 52
export const TAB_BAR_HEIGHT = 58

export const TopBar = styled('div')`
  display: none;

  ${mobileOnly} {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1100;
    display: flex;
    align-items: center;
    gap: 4px;
    height: calc(${TOP_BAR_HEIGHT}px + env(safe-area-inset-top, 0px));
    padding: env(safe-area-inset-top, 0px) 12px 0 16px;
    background: #F5F7F9;
    border-bottom: 1px solid #E9ECEF;
  }
`

export const BackButton = styled('button')`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 32px;
  height: 36px;
  margin-left: -10px;
  padding: 0;
  border: none;
  background: transparent;
  color: #272E35;
  cursor: pointer;
`

export const TopBarTitle = styled('div')`
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 17px;
  line-height: 24px;
  font-weight: 600;
  color: #272E35;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

// Сюда страницы переносят свою главную кнопку. Маленькие квадратные кнопки с
// иконкой: длинная подпись в узкую панель не помещается
export const ActionSlot = styled('div')`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const TabBar = styled('nav')`
  display: none;

  ${mobileOnly} {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1300;
    display: flex;
    height: calc(${TAB_BAR_HEIGHT}px + env(safe-area-inset-bottom, 0px));
    padding: 0 4px env(safe-area-inset-bottom, 0px);
    background: #FFFFFF;
    border-top: 1px solid #E9ECEF;
  }
`

export const TabButton = styled('button')`
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 6px 2px 4px;
  border: none;
  background: transparent;
  font: inherit;
  color: #7E8B99;
  text-decoration: none;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  &.active {
    color: #1D4ED8;
  }
`

export const TabIcon = styled('span')`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 28px;
  border-radius: 14px;
  transition: background 0.15s;

  // Иконки набора нарисованы серой заливкой и цвет не наследуют, поэтому
  // активную вкладку выделяет подложка, а не перекраска
  & svg {
    width: 22px;
    height: 22px;
    flex: 0 0 22px;
    margin: 0;
  }

  &.active {
    background: #E8F0FF;
  }

  &.active > svg {
    color: #1D4ED8;
  }
`

export const TabLabel = styled('span')`
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 11px;
  line-height: 14px;
  font-weight: 500;
`

export const TabBadge = styled('span')`
  position: absolute;
  top: 2px;
  right: 10px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #2563EB;
  border: 2px solid #FFFFFF;
  box-sizing: content-box;
`

export const AvatarButton = styled('button')`
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  padding: 0;
  margin-left: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: none;
  border-radius: 50%;
  background: #D7E4FF;
  color: #05205E;
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  cursor: pointer;

  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const AvatarMenuHead = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 200px;
  padding: 8px 16px 10px;
  font-size: 13px;
  color: #555F6D;

  & strong {
    font-size: 14px;
    color: #272E35;
  }
`
